<template lang="pug">
common-table.mb-10(
  :headers="headers"
  :items="items"
  @on-click="onClickNextIcon"
  :max-width="maxWidth"
  :loading="loading"
  :item-key="itemKey"
  :on-no-data-message="onNoDataMessage"
)
  template(v-slot:name="{item}")
    div(v-if="isShowView")
      v-icon(medium).mr-2 mdi-folder-open-outline
      span.link-text {{ item.name }}
    div(v-else) {{ item.name }}
  template(v-slot:name_display="{item}")
    div(v-if="isShowView")
      v-icon(medium).mr-2 mdi-folder-open-outline
      span.link-text {{ item.name_display }}
    div(v-else) {{ item.name_display }}
  template(v-if="isShowDestination" v-slot:is_default="{item}")
    div(v-if="item.is_default")
      span {{$t('payment_destination.is_default')}}
  template(v-if="isShowDestination" v-slot:account_type="{item}")
    //- span {{ convertAccountType(item.account_type) }}
  template(v-slot:action="{item}")
    v-menu(
      v-if="isActive && !loading"
      left
      offset-y
      min-width="9vw"
    )
      template(v-slot:activator='{on}')
        v-btn(v-on='on' icon)
          v-icon(medium) mdi-dots-vertical
      v-list
        v-list-item(v-for="(action, i) in actions" :key="i" link @click="emitAction(action.action, item)")
          v-icon.pr-3(:color="action.color") {{ action.icon }}
          v-list-item-title {{ $t(action.text) }}
    v-btn.mr-2.hidden-xs-only.button(v-else-if="!loading && !isShowReadOnly" color="black" outlined dark @click.stop="onRevertItem(item)")
      span {{ $t('common.btn_revert') }}

  template(v-for='(_, name) in $scopedSlots' #[name]='slotProps')
    slot(v-bind='slotProps', :name='name')
</template>
<script>
import { defineComponent, computed } from 'vue'
import CommonTable from '../CommonTable/index'
// import { accountType } from '../../pages/Master/PaymentDestination/index'

const JMasterItemList = defineComponent({
  props: {
    maxWidth: {
      type: Number,
      // 文字数が長い対応のため、1000→1200
      default: 1200,
      required: false
    },
    isShowDestination: {
      type: Boolean,
      required: false,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    isShowView: {
      type: Boolean,
      required: false,
      default: false
    },
    actions: {
      type: Array,
      required: false,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false,
      required: false
    },
    isActive: {
      type: Boolean,
      default: true,
      required: false
    },
    itemKey: {
      type: String,
      required: false
    },
    onNoDataMessage: {
      type: String || null,
      default: null,
      required: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isMaster: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CommonTable
  },
  setup(props, { emit }) {
    const isShowReadOnly = computed(() => {
      return !(!props.readOnly || !props.isMaster)
    })

    // Click to open unit of each group
    const onClickNextIcon = (item) => {
      emit('go-to-master-detail', item)
    }

    const onRevertItem = (item) => {
      emit('handle-revert-item', item)
    }

    // emit all action (on-update, on-delete)
    const emitAction = (action, item) => {
      emit(action, item)
    }
    // const convertAccountType = (item) => {
    //   const found = accountType.find((at) => at.value === item)
    //   return found ? found.text : ''
    // }

    return {
      onClickNextIcon,
      emitAction,
      // convertAccountType,
      onRevertItem,
      isShowReadOnly
    }
  }
})
export default JMasterItemList
</script>

<style scoped lang="sass">
@import '@/style/css/common.sass'
.home
  width: 100%

.btn
  border: 0px

.link-text
  color: blue
  text-decoration: underline

::v-deep table > thead > tr > th > span
  color: white !important
  font-size: 16px

::v-deep table > tbody > tr > td
  font-size: 16px !important
</style>
